/**
 * Het vaste document-ID van het aanwezigheidsrapport dat bij één roosterregel
 * op één dag hoort.
 *
 * De nachtklus en een melding vanuit de agenda schrijven naar dit ene document.
 * Wie het eerst is legt vast; de klus gebruikt `create` en slaat over als het er
 * al staat. Zo kunnen 'afwezig' en 'aanwezig' niet meer naast elkaar bestaan
 * (inbox #327).
 *
 * SPIEGEL: functions/personas/presenceReportDocId.js — vastgepind door
 * functions/personas/presenceReportDocId.test.js.
 *
 * AI-CONTEXT: See docs/pitfalls.md#database-job-dedups-only-on-its-own-docid
 *
 * @param {string} scheduleID - Document-ID van de roosterregel (Task, Type personaSchedule)
 * @param {string} dateKey - De dag als YYYY-MM-DD in Amsterdamse tijd
 * @returns {string} Het document-ID, of '' als er iets ontbreekt
 */
const presenceReportDocId = (scheduleID, dateKey) => {
    if (!scheduleID || !dateKey) return ''
    return `presence_${scheduleID}_${dateKey}`
}

export default presenceReportDocId
